module.exports = __webpack_public_path__ + "static/img/headaBj.a06afe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/headaBj.png
// module id = PUwk
// module chunks = 89